export default __webpack_public_path__ + "static/media/logo@2x.16342cf6.png";